import * as React from 'react';
import { observer } from 'mobx-react';

// Components
import Button from '../Button';
import Dialog, { DialogTitle, DialogContent, DialogContentText, DialogActions } from './';

// Component
export interface IProps {
    state: { open: boolean; title: string; description: string; };
    onClose?: () => void;
    onConfirm?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
}

function AlertDialog({ state: { open, title, description }, onClose, onConfirm }: IProps) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{description}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onConfirm} color="primary">Okay</Button>
            </DialogActions>
        </Dialog>
    );
}

export default observer(AlertDialog);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dialog/AlertDialog.tsx